export default __webpack_public_path__ + "static/media/jsx.53e3659b.png";